import React from 'react';
import { Container } from '@adobe/cq-react-editable-components';
import { CompareBill } from '@plans/blocks';
import { ButtonGroup, TextLink } from '@vds/buttons';
import { Col, Row } from '@vds/grids';
import { Title } from '@vds/typography';
import styled from 'styled-components';
import { ModalBody, ModalFooter, ModalTitle } from '@vds/modals';
import { Notification } from '@vds/notifications';
// import Heading from '../../../common/Heading/head';
import { Line } from '@vds/lines';
import { VDSModal as Modal } from '../../../common/Modal/VDSModal';
import { getSession, isMobile, isWHWP2 } from '../../../common/Helpers';
import FWAContainer from '../../../common/FWAContainer';
import { Body } from '../../../common/Typography';
import { Margin, StyledVdsCol } from '../../../common/styles';
import Button from '../../../common/Button';
import { goToProcessStep } from '../../../../redirection';
import NBSModal from '../../../NextGen/NBS/NBSModal';
import { store } from '../../../../configureStore';
import { eventDispatcher } from '../../../common/Tagging';

const StyledCompareBill = styled.div`
  * {
    box-sizing: unset !important;
  }
`;


export default class whwPlusReviewOrder extends Container {
  componentDidMount() {
    store.dispatch({ type: 'NBS_GET_PAGE_DATA' });
    if (!this.state.invokeTagging && isWHWP2()) {
      this.props.invokeTaggingAPI();
      this.setState({ invokeTagging: true });
    }
  }

  addonspage = () => {
    const updateView = {
      nextStep: 'Addons',
      nextViewPage: 'addons.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    };
    goToProcessStep(updateView, this.props.history);
  };

  confirmationRedirect = () => {
    this.props.callSubmitOrder('ReviewOrderPage');
  };

  downgradeModalChange = (value) => {
    this.setState({ showDowngradeModal: value });
    if (!value) {
      eventDispatcher('linkClick', {
        type: 'link',
        name: `close`,
        data: { page: { detail: `Details | ${this.props?.downgradeHeader} modal` } },
      });
    }
  };

  NbsChange = () => {
    this.setState({ showModal: false });
    eventDispatcher('linkClick', {
      type: 'link',
      name: `close`,
      data: { page: { detail: `Bill details modal` } },
    });
  }

  render() {
    const updateView = {
      nextStep: 'Confirmation',
      nextViewPage: 'confirmation.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    };
    if (this.props?.reviewOrderState?.isSubmitSuccess) {
      goToProcessStep(updateView, this.props.history);
    }
    const billData = {
      oldBill: {
        title: {
          children: 'Current bill',
        },
        price: {
          children: this.props?.DowngradeCurrentBill,
        },
      },
      newBill: {
        title: {
          children: 'New bill',
          superscript: {
            children: '*',
          },
        },
        price: {
          children: this.props?.DowngradeNewBill,
        },
        // subtitle: {
        //   children: this.props?.DowngradeNewBill,
        // },
      },
      footnote: {
        children: (
          <>
            <TextLink
              type="inline"
              id="nbsindex-test"
              data-track={`{"type": "link", "name": "Bill-Details", "data": {"page": {"detail": "Bill-Details modal"}}}`}
              onClick={(e) => {
                e.preventDefault();
                this.setState({ showModal: true });
              }}
            >
              Bill details
            </TextLink>
          </>
        ),
        // children: (
        //   <>
        //     {/* <TextLink type="inline">
        //       Bill details
        //     </TextLink> */}
        //     {NBSComponents}
        //   </>
        // ),
      },
    };

    const returnedQuantity = JSON.parse(getSession('downgradeDetails')).returnqty;
    const notificationProps = {
      renderIf: true,
      title: this.props?.downgradeTitle,
      type: 'warning',
      serviceInfo: '',
      subtitle: this.props?.downgradeSubTitle.replace('XX.XX', returnedQuantity),
      hideCloseButton: true,

      buttonData: [
        {
          children: 'Details',
          id: 'notificationDetails',
          onClick: () => this.setState({ showDowngradeModal: true }),
          'data-track': `{"type": "link",  "name": "Details", "data":{"page":{"detail":"Details | ${this.props?.downgradeHeader} modal" }}}`,
        },
      ],
    };

    return (
      isWHWP2() && (
        <>
          <Row>
            <Col>
              {this.state.showDowngradeModal && (
                <Modal
                  ariaLabel="Downgrade overlay"
                  analyticstrack="redemption Downgrade Modal"
                  opened={this.state.showDowngradeModal}
                  data-track="{}"
                  onOpenedChange={this.downgradeModalChange}
                  openViewData={{
                    name: `Details | ${this.props?.downgradeHeader} modal`,
                    selector: '#DowngradeModal',
                  }}
                  disableOutsideClick
                >
                  <ModalTitle> {this.props?.downgradeHeader}</ModalTitle>
                  <ModalBody>
                    <div dangerouslySetInnerHTML={{ __html: this.props?.downgradeDescription }} />
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      width={isMobile() ? '100%' : 'auto'}
                      onClick={() => this.setState({ showDowngradeModal: false })}
                      data-track={`{"type": "link", "name": "Got it","data":{"page":{"detail":"Details | ${this.props?.downgradeHeader} modal" }}}`}
                    >
                      Got it
                    </Button>
                  </ModalFooter>
                </Modal>
              )}
            </Col>
          </Row>
          <Row>
            {this.state.showModal && (
              <NBSModal
                isOpen={this.state.showModal}
                data-track="{}"
                isDowngradeRedemption={this.state.showModal}
                change={this.NbsChange}
              />
            )}
          </Row>
          <FWAContainer className="redesignOrderReviewContainer" rowGutter="10px" topBufferAuto enableLiveSupport title={this.props?.title}>
            <Row className="orderReviewContainer">
              <Col colSizes={{ mobile: 4, tablet: 11, desktop: 12 }}>
                <Title size="large" bold={false} color="#000000">
                  {this.props?.whwDowngradeHeader}
                </Title>
              </Col>
              <StyledVdsCol style={{ width: window.innerWidth > '768' && '810px' }} colSizes={{ mobile: 4, tablet: 9, desktop: 8 }}>
                <Margin bottom="25px">
                  <div>
                    <Body color="#6F7171" size={isMobile() ? 'medium' : 'large'}>
                      {this.props?.whwDowngradeSubHeader}
                    </Body>
                  </div>
                </Margin>
              </StyledVdsCol>

              <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                <Margin bottom="25px">
                  <Notification {...notificationProps} />
                </Margin>
              </Col>
              <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                <StyledCompareBill>
                  <CompareBill {...billData} />
                </StyledCompareBill>
              </Col>
            </Row>
            <StyledCompareBill>
              <Line type="secondary" className="margin30 onlyTopMargin" />
            </StyledCompareBill>

            {/* </Margin> */}
            {/* </Col> */}
            <Row>
              <Col colSizes={{ mobile: 4, tablet: 11, desktop: 12 }}>
                {isMobile() ? (
                  <Margin top="25px" bottom="25px">
                    <ButtonGroup
                      childWidth="auto"
                      viewport="mobile"
                      alignment="center"
                      rowQuantity={{ mobile: 1 }}
                      data={[
                        {
                          children: 'Confirm',
                          width: '100%',
                          'data-testid': 'apply_offer_cta',
                          size: 'large',
                          use: 'primary',
                          ariaLabel: 'Confirm extender return',
                          // width: '',
                          onClick: this.confirmationRedirect,
                        },
                        {
                          children: 'cancel',
                          'data-testid': 'no_thanks_cta',
                          size: 'large',
                          use: 'textLink',
                          width: 'auto',
                          ariaLabel: 'Cancel extender return',
                          onClick: this.addonspage,
                        },
                      ]}
                      // alignment={isMobile() ? 'center' : 'left'}
                    />
                  </Margin>
                ) : (
                  <Margin top="25px" bottom="25px">
                    <ButtonGroup
                      childWidth="auto"
                      viewport="desktop"
                      alignment="left"
                      rowQuantity={{ desktop: 2 }}
                      data={[
                        {
                          children: 'Confirm',
                          width: 'auto',
                          size: 'large',
                          use: 'primary',
                          onClick: this.confirmationRedirect,
                        },
                        {
                          children: 'cancel',
                          size: 'large',
                          use: 'textLink',
                          width: 'auto',
                          onClick: this.addonspage,
                        },
                      ]}
                    />
                  </Margin>
                )}
              </Col>
            </Row>
          </FWAContainer>
        </>
      )
    );
  }
}
